// src/hooks/useDarkMode.js

import { useState, useEffect } from 'react';

export function useDarkMode() {
  // 1. Tenta pegar o tema do localStorage.
  // 2. Se não houver nada salvo, usa 'dark' como padrão, em vez de 'light'.
  const [theme, setTheme] = useState(() => {
    const savedTheme = window.localStorage.getItem('theme');
    return savedTheme || 'dark'; // <<< A MUDANÇA ESTÁ AQUI
  });

  // Função para alternar o tema
  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  // Efeito que aplica a classe ao HTML e salva no localStorage
  useEffect(() => {
    const root = window.document.documentElement;

    // Remove a classe antiga e adiciona a nova
    root.classList.remove(theme === 'dark' ? 'light' : 'dark');
    root.classList.add(theme);

    // Salva a preferência no localStorage
    window.localStorage.setItem('theme', theme);
  }, [theme]); // Roda sempre que o 'theme' mudar

  return [theme, toggleTheme];
}
